/** #@condition: digital **/
import MojitoServices from 'mojito/services';

import {ensureHierarchy} from '#core/utils/config-utils.js';

import {AbstractFeature, allFeatures} from '#core/application/abstract-feature.js';

import {DummyBalanceService} from './dummy-balance-service.js';

import SCHEMA from './balance.schema.yaml';

const balanceService = MojitoServices.UserInfo.Balance.service;

class BalanceFeature extends AbstractFeature {
    get configSchema() {
        return SCHEMA;
    }

    updateMojitoConfig(mojitoConfig) {
        const config = this.config;
        const userInfoService = ensureHierarchy(mojitoConfig, 'services.userInfoService');

        // Push default balance service that doing roundtrip client<->user-service<->integration-service<->ims
        // Only if pollingInterval > 0
        if (config.pollingInterval !== 0) {
            // services.userInfoService.balanceService
            userInfoService.balanceService = balanceService.configure({
                balanceUpdateIntervalSeconds: config.pollingInterval,
            });
        } else {
            // Push something if no balance services are provided (prevent mojito crashing)
            // Note: Balance could be updated via Sportsbook/Lotto API
            userInfoService.balanceService = new DummyBalanceService();
        }

        super.updateMojitoConfig(mojitoConfig);
    }
}

new BalanceFeature(allFeatures);
